import RouteWrapper from "@/components/common/RouteWrapper.vue";
import RouteNames from "@/entities/RouteNames";
import NavigationIcons from "@/entities/NavigationIcons";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";

const Postings = () =>
  import("@/views/recruiting/RecrutingPostings.vue").then((m) => m.default);
const PostingApplications = () =>
  import("@/views/recruiting/postingDetails/PostingApplicationsV2.vue").then(
    (m) => m.default
  );
const PostingDetails = () =>
  import("@/views/recruiting/postingDetails/PostingDetailsV2.vue").then(
    (m) => m.default
  );
const Posting = () =>
  import("@/views/recruiting/PostingV2.vue").then((m) => m.default);

const getPostingsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/postings",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_COMPANIES,
        routeName: RouteNames.RECRUITING_POSTINGS,
        copyLink: false,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.RECRUITING_POSTINGS,
        component: Postings,
        meta: {
          title: "Postings",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.POSTINGS,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getPostingPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.RECRUITING_POSTING,
    redirect: {
      name: RouteNames.RECRUITING_POSTINGS,
    },
  },
  {
    path: "details",
    name: RouteNames.RECRUITING_POSTING_DETAILS,
    component: PostingDetails,
    meta: {
      title: "Job Postings",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.POSTINGS,
        isStyled: true,
      },
    },
  },
  {
    path: "applicants",
    name: RouteNames.RECRUITING_POSTING_APPLICATIONS,
    component: PostingApplications,
    meta: {
      title: "Posting applicants",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "review",
    name: RouteNames.RECRUITING_POSTING_REVIEW,
    component: PostingApplications,
    meta: {
      title: "Applicants Under Review",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
    props: { review: true },
  },
  {
    path: "approved",
    name: RouteNames.RECRUITING_POSTING_APPROVED,
    component: PostingApplications,
    meta: {
      title: "Approved Applicants",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
    props: { approved: true },
  },
  {
    path: "declined",
    name: RouteNames.RECRUITING_POSTING_DECLINED,
    component: PostingApplications,
    meta: {
      title: "Declined Applicants",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
    props: { declined: true },
  },
  {
    path: "cancelled",
    name: RouteNames.RECRUITING_POSTING_CANCELLED,
    component: PostingApplications,
    meta: {
      title: "Withdrawn Applicants",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
    props: { cancelled: true },
  },
]);

const getPostingPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    component: Posting,
    props: true,
    meta: {
      title: "Posting",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.POSTING_DETAILS,
        isStyled: true,
      },
    },
  },
]);

export {
  getPostingsRoutes,
  getPostingPrivatePageRoutes,
  getPostingPrivatePageTabsRoutes,
};
